import React              from 'react';
import { useTranslation } from 'react-i18next';

// Characteristic table of one card section, rendered from offer.sections (parameter sections and
// parameters configured in the admin panel). A section with two-sided parameters is a three-column
// table (label / outside / inside); one-sided parameters there take one cell across both columns.

const Value = function({ cell, title, showInfo }) {
  if (!cell) {
    return null;
  }

  return (
    <>
      {cell.value}
      {typeof cell.description === 'string' && cell.description.trim() !== '' && (
        <i
          className={'ic-question'}
          onClick={(event) => {
            const rect = event.target.getBoundingClientRect();
            showInfo(title, cell.description, rect.top);
          }}
        />
      )}
    </>
  );
};

const TableSection = function({ section, showInfo }) {
  const { t } = useTranslation();
  const rows  = section?.rows || [];

  if (section?.hasDual) {
    return (
      <div className={'table'}>
        <div className={'table_wrapper'}>
          <div className={'grid_table_title_wrapper'}>
            <span></span>
            <span>{t('label_outside')}</span>
            <span>{t('label_inside')}</span>
          </div>
          <div className={'body'}>
            {rows.map((row) => (
              <div className={'grid_table_value'} key={row.alias}>
                <span className={'label'}>{row.label}</span>
                {row.isDual
                  ? (
                    <>
                      <span className={'value_outside'}>
                        <Value cell={row.value.outside} title={row.value.outside?.value} showInfo={showInfo} />
                      </span>
                      <span className={'value_inside'}>
                        <Value cell={row.value.inside} title={row.value.inside?.value} showInfo={showInfo} />
                      </span>
                    </>
                  )
                  : (
                    <span className={'value_both'}>
                      <Value cell={row.value} title={row.value?.value} showInfo={showInfo} />
                    </span>
                  )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={'table'}>
      <div className={'table_wrapper'}>
        <div className={'body'}>
          {rows.map((row) => (
            <div className={'table_value'} key={row.alias}>
              <span className={'label'}>{row.label}</span>
              <span className={'value'}>
                <Value cell={row.value} title={row.label} showInfo={showInfo} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableSection;
